export type Scope = 'maintainers' | 'student' | 'teacher';

export type MicrosoftErrorCode =
  | 'MICROSOFT_OAUTH_ERROR'
  | 'STATE_INVALID'
  | 'TOKEN_EXCHANGE_FAILED'
  | 'ID_TOKEN_INVALID'
  | 'ACCOUNT_NOT_FOUND'
  | 'ACCOUNT_DISABLED'
  | 'NOT_SCOPE'
  | 'PROVIDER_NOT_ENABLED'
  | 'MICROSOFT_NOT_CONFIGURED';

export interface ParsedMicrosoftError {
  code: MicrosoftErrorCode;
  email?: string;
  availableScopes?: Scope[];
  targetPortalUrl?: string;
}

const VALID_CODES: ReadonlySet<MicrosoftErrorCode> = new Set<MicrosoftErrorCode>(
  [
    'MICROSOFT_OAUTH_ERROR',
    'STATE_INVALID',
    'TOKEN_EXCHANGE_FAILED',
    'ID_TOKEN_INVALID',
    'ACCOUNT_NOT_FOUND',
    'ACCOUNT_DISABLED',
    'NOT_SCOPE',
    'PROVIDER_NOT_ENABLED',
    'MICROSOFT_NOT_CONFIGURED',
  ],
);

const VALID_SCOPES: ReadonlySet<Scope> = new Set<Scope>([
  'maintainers',
  'student',
  'teacher',
]);

export function parseMicrosoftError(
  searchParams: URLSearchParams,
): ParsedMicrosoftError | null {
  const raw = searchParams.get('error');
  if (!raw) {
    return null;
  }
  if (!VALID_CODES.has(raw as MicrosoftErrorCode)) {
    return null;
  }

  const result: ParsedMicrosoftError = { code: raw as MicrosoftErrorCode };

  const email = searchParams.get('email');
  if (email) {
    result.email = email;
  }

  const availableCsv = searchParams.get('availableScopes');
  if (availableCsv) {
    const parsed = availableCsv
      .split(',')
      .map((s) => s.trim())
      .filter((s): s is Scope => VALID_SCOPES.has(s as Scope));
    if (parsed.length) {
      result.availableScopes = parsed;
    }
  }

  const targetPortalUrl = searchParams.get('targetPortalUrl');
  if (targetPortalUrl && /^https?:\/\//.test(targetPortalUrl)) {
    result.targetPortalUrl = targetPortalUrl;
  }

  return result;
}
